import type { ReactNode } from 'react';

import { useApplicationContext } from '~/shared/context/use-application-context';

import { AnnouncementsMegaphone } from './AnnouncementsMegaphone';

export const useAnnouncementsMegaphoneListItem = (): ReactNode => {
    const { applicationState } = useApplicationContext();
    const isEnabled = applicationState.featureFlagService.isFeatureFlagEnabled('announcements-enabled');

    if (!isEnabled) {
        return null;
    }

    return <AnnouncementsMegaphone />;
};
